/**
 * Logo officiel Faanuu (.app)
 */
export default function Logo({ className = "", size = "md" }) {
  const heights = {
    xs: "h-8",
    sm: "h-11",
    md: "h-16",
    lg: "h-28",
    xl: "h-44",
  };
  return (
    <img
      src="/logo.png"
      alt="Faanuu — le jeu du roi tahitien"
      className={`${heights[size] || heights.md} w-auto object-contain ${className}`}
      data-testid="faanuu-logo"
    />
  );
}
